export const filterKeyMappings = {
  leaseDate: ['minLeaseDate', 'maxLeaseDate'],
  price: ['minPrice', 'maxPrice'],
  buildingSize: ['minBuildingSize', 'maxBuildingSize'],
  lotSize: ['minLotSize', 'maxLotSize'],
  units: ['minUnits', 'maxUnits'],
  state: ['state'],
  zip: ['zip']
};

export const filterLabelMappings = {
  acres: 'Acres',
  leaseDate: 'Lease Date',
  price: 'Sale Price',
  sf: 'SF',
  buildingSize: 'Builidng Size',
  investmentTypes: 'Investment Types',
  lotSize: 'Lot Size',
  state: 'State',
  units: 'Units',
  zip: 'Zip'
};

export const columnTypes = {
  parentName: 'alpha',
  name: 'alpha',
  city: 'alpha',
  createdAt: 'amount',
  propertyTypes: 'alpha',
  transactionTypeFormatted: 'alpha',
  minSalePriceFormatted: 'amount',
  maxSalePriceFormatted: 'amount',
  minLeaseDateFormatted: 'amount',
  maxLeaseDateFormatted: 'amount',
  minBuildingSizeFormatted: 'amount',
  maxBuildingSizeFormatted: 'amount',
  minLotSizeFormatted: 'amount',
  maxLotSizeFormatted: 'amount',
  minNumberOfUnits: 'amount',
  maxNumberOfUnits: 'amount'
};

export const propertyInformationMappings = {
  minSalePriceFormatted: 'Min Sale Price',
  maxSalePriceFormatted: 'Max Sale Price',
  minLeaseDateFormatted: 'Min Lease Date',
  maxLeaseDateFormatted: 'Max Lease Date',
  minBuildingSizeFormatted: 'Min Building Size',
  maxBuildingSizeFormatted: 'Max Building Size',
  minLotSizeFormatted: 'Min Lot Size',
  maxLotSizeFormatted: 'Max Lot Size',
  minNumberOfUnits: 'Min Units',
  maxNumberOfUnits: 'Max Units',
  investmentTypeLabels: 'Investment Types',
  createdAt: 'Date Created',
  city: 'City',
  state: 'State',
  zip: 'Zip',
  notes: 'Notes'
};

export const defaultColumnMappings = {
  parentName: 'Contact/Company',
  name: 'Requirement Name',
  transactionTypeFormatted: 'Transaction Type',
  propertyTypes: 'Property Type',
};

export const excludedColumns = [
  'state',
  'zip',
  'notes',
  'investmentTypes'
];

export const requirementInformationMappings = {
  propertyInformation: {
    title: 'Property Information',
    mappings: propertyInformationMappings,
    key: 'property-info'
  }
};

export const initialState = {
  investmentTypes: [],
  transactionTypes: [],
  sort: '',
  propertyTypes: [],
  searchText: '',
  addressFilter: {
    cities: [],
    state: '',
    zip: '',
    currentCity: ''
  },
  propertyFilter: {
    buildingSizeUnits: '',
    lotSizeUnits: '',
    maxLeaseDate: null,
    maxPrice: '',
    maxBuildingSize: '',
    maxLotSize: '',
    maxUnits: '',
    minLeaseDate: null,
    minPrice: '',
    minBuildingSize: '',
    minLotSize: '',
    minUnits: ''
  }
};
